{
  "title": "Mass Cure Wounds",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level evocation",
  "level": 5,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "A wave of healing energy washes out from a point of your choice within range. Choose up to six creatures in a 30-foot-radius sphere centered on that point. Each target regains hit points equal to 3d8 + your spellcasting ability modifier. This spell has no effect on undead or constructs.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, the healing increases by 1d8 for each slot level above 5th."
  ],
  "spellLists": ["bard", "cleric", "druid"]
}
